import React from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';
import BackgroundBlocks from '../../img/blocks-background.webp'
import BackgroundBlocksMob from '../../img/blocks-background-mob.webp'

function EbAutOne({ ebautData }) {

    return (
        <>
            {ebautData && (

                <section id="ebaut" className="eut-abot relative mb-[60px] md:mb-[120px] pt-60 md:pt-64 lg:pt-80" >
                    <div className="container max-w-screen-xl mx-auto px-[15px] relative">
                        <ScrollAnimation animateIn="animate__fadeInUp">
                            <h2 className="font-bold uppercase text-3xl text-center text-[#245864] mb-8
                                sm:text-4xl md:mb-14 lg:text-left lg:mb-0 lg:text-[60px] relative z-20">Про івент</h2>
                        </ScrollAnimation>

                        <ScrollAnimation animateIn="animate__fadeInUp">
                            <div className="flex flex-col md:flex-row md:gap-5 md:items-start lg:items-end xl:gap-16">
                                {/*<div className="relative w-full mb-8 md:mb-0 md:w-1/2 pt-[56%] md:pt-[28%] overflow-hidden
                                    lg:max-w-[500px]">
                                    <iframe
                                        className="absolute inset-0 w-full h-full"
                                        src="https://www.youtube.com/embed/E34cLKeyPAs?si=N_2ceyw_9mESTRKT"
                                        title="YouTube video player"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        referrerPolicy="strict-origin-when-cross-origin"
                                        allowFullScreen
                                    />
                                </div>*/}
                                <div className="text-lg text-[#235763] md:pl-10 lg:max-w-[860px]  lg:pt-11 xl:pt-24 relative z-20">

                                    <p className="font-semibold mb-8 xl:mb-10">
                                        <strong>Вже більше 10 років She Congress разом із жінками</strong>, які розвивають бізнес, будують кар’єру, створюють нові проєкти, змінюють суспільство та надихають інших.
                                    </p>
                                    <p className="mb-8 xl:mb-10">
                                        За цей час змінювалися ми і змінився сам світ. Ми говорили про цей шлях зі сцени і за лаштунками. Збирали разом тих, хто не знецінює і не конкурує, а готовий обʼєнуватися. Допомагали бачити силу одна одної. Нагадували про масштаб кожної.
                                    </p>

                                    <p className="mb-8 xl:mb-10">Ми продовжуємо розвивати SHE Congress разом із вами. <strong>Створюємо досвід, який обʼєднує, та формуємо нову культуру взаємодії.</strong> </p>
                                
                                    <p>SHE Congress сьогодні – це вже не просто про знайомства. Тут ми знаходимо «своїх». Тих, хто розділяє цінності й підходи, готовий об’єднуватися, пробувати нове та пірнати у сміливі колаборації.</p>
                                
                                </div>
                            </div>
                        </ScrollAnimation>
                    </div>
                    <div  className="absolute top-0 left-0 w-full h-48 md:h-96 lg:h-[485px] z-10">
                        <img src={BackgroundBlocks} alt="" className="absolute hidden md:block object-cover w-full h-full" />
                        <img src={BackgroundBlocksMob} alt="" className="absolute md:hidden object-cover w-full h-full" />
                   </div>
                </section>
            )}
        </>
    );

}

export default EbAutOne